export default __webpack_public_path__ + "static/media/BannerInterShop.758e3c96.png";